import Vue from 'vue';
import store from 'store';
import {Scrollbar, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    el,
    store,
    components: {
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    data: () => ({
      swiperOptions: {
        slidesPerView: 1.32,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        a11y: true,
        keyboard: true,
        modules: [Scrollbar, A11y, Keyboard],
        breakpoints: {
          769: {
            slidesPerView: 3,
          }
        }
      }
    }),
    methods: {},
  });
